<app-page-up type="full" [minHeight]="sizesConfig?.minHeight" [maxHeight]="sizesConfig?.maxHeight">
  <div class="checkin__booking__detail__header" [ngStyle]="{ 'background-image' : 'url(' + accImg + ')' }"
    [ngClass]="{ 'checkin__booking__detail__header--has-payments' : showPaymentsDetail }" top>
    <div class="acc__name">{{ sidebarData.name }}</div>
    <div class="acc__location">
      <i class="avc-location"></i>
      <span>{{ sidebarData.city || sidebarData.country }}</span>
    </div>
    <div class="checkin__booking__detail__header__overlay"></div>
  </div>
  <div class="checkin__booking__detail__content__wrapper"
    [ngClass]="{ 'checkin__booking__detail__content__wrapper--has-payments' : showPaymentsDetail }" bottom>
    <div class="checkin__booking__detail__content"
      [ngClass]="{ 'checkin__booking__detail__content__padding--bottom' : !showBookingPrice }">
      <app-booking-detail-dates *ngIf="datesAllowed" [hasPayments]="showPaymentsDetail"></app-booking-detail-dates>
      <ng-container *ngTemplateOutlet="isStatusCustomTemplate ? customTemplate : default"></ng-container>
    </div>
  </div>
</app-page-up>

<ng-template #customTemplate>
  <div class="checkin__booking__detail__content__status">
    <app-booking-status></app-booking-status>
  </div>
</ng-template>
<ng-template #default>
  <div class="checkin__booking__detail__content__id">{{ sidebarData?.bookingId }}</div>
  <div *ngIf="showModifyOccupants" class="checkin__booking__detail__content__occupants">
    {{ occupantsInfoLabel }}
    <app-button-secondary [ngClass]="cta__prevent__hide" [text]="'payment-modify-card'" (click)="redirectToOLB()">
    </app-button-secondary>
  </div>
  <ng-container *ngIf="showBookingPrice">
    <app-payments-detail *ngIf="showPaymentsDetail" [fullBookingDetail]="full">
    </app-payments-detail>
    <app-booking-price [full]="!showPaymentsDetail">
    </app-booking-price>
  </ng-container>
  <app-booking-card *ngIf="showCreditCard && isResponsive"
    [ngClass]="{ 'checkin__booking__detail__card--top' : showBookingPrice }">
  </app-booking-card>
</ng-template>